export default "201ccee5dcb1e9d3.ttf"